import {TablePagination} from '@material-ui/core'
import _t, {_} from 'i18n'
import React from 'react'
import {useDispatch} from 'react-redux'

import Skeleton from './skeleton'
import {Container} from './styles'

const LIMIT = 25

const ProposalPagination = ({loading, page, total, limit = LIMIT, changeLimit, changePage}) => {
  const dispatch = useDispatch()

  const onChangePage = (_, page) => {
    dispatch(changePage(page))
  }

  const handleChangeRowsPerPage = (e) => {
    dispatch(changeLimit(e.target.value))
  }

  if (loading) {
    return <Skeleton />
  }

  return (
    <Container>
      <TablePagination
        rowsPerPageOptions={[25, 50, 100]}
        component="div"
        labelRowsPerPage={_`Itens por página`}
        count={total}
        rowsPerPage={limit}
        page={page}
        onChangePage={onChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        nextIconButtonText={_`Próxima Página`}
        backIconButtonText={_`Página anterior`}
      />
    </Container>
  )
}

export default ProposalPagination
